import api from "../../http";

export default class ApiAboutProductsAndServices {
  static async getApiAboutProductsAndServices(url) {
    return api.get(url)
  }
}